const translations = {
    pl: {
        header: {
            primary: "Szybkie Wypo - generator wypowiedzenia umowy",
            secondary: "Najszybsze wypowiedzenie w mieście",
            description: "Masz dość? Czas na zmiany? A może pojawiła się lepsza oferta? Nie czekaj - skorzystaj z naszego generatora wypowiedzenia i rzuć papierem już dziś!"
        },
        ui: {
            generateBtn: "Generuj wypowiedzenie",
            downloadBtn: "Pobierz",
            langSelector: "język",
            cookieInfoMessage: "Strona korzysta z plików cookie w celu realizacji usług zgodnie z <a href=\"polityka-prywatnosci\">Polityką Prywatności</a>. Możesz określić warunki przechowywania lub dostępu mechanizmu cookie w Twojej przeglądarce.",
            cookieInfoAcceptBtn: "Akceptuję" 
        },
        form: {
            contractType: "Typ umowy",
            contractOfEmployment: "Umowa o pracę",
            contractOfWork: "Umowa zlecenie",
            contractB2B: "B2B",
            employee: "Pracownik",
            contractor: "Zleceniobiorca",
            nameAndSurname: "Imię i nazwisko",
            contractorComanyName: "Nazwa firmy",
            address: "Adres",
            city: "Miejscowość",
            postalCode: "Kod pocztowy",
            employer: "Pracodawca",
            customer: "Zleceniodawca",
            comanyName: "Nazwa",
            companyTaxNr: "NIP",
            noticePeriod: "Okres wypowiedzenia",
            noticePeriodOneMonth: "1 miesiąc",
            noticePeriodThreeMonths: "3 miesiące",
            noticePeriodOther: "Inny",
            noticePeriodPlaceholder: "(np. 14 dni)",
            additionalInfo: "Dodatkowe informacje",
            dateOfNotice: "Data złożenia wypowiedzenia",
            contractDate: "Data zawarcia umowy",
            contractNumber: "Numer umowy (opcjonalnie)",
            validationMsg: "Formularz zawiera błedy"
        }
    },
    ua: {
        header: {
            primary: "Генератор припинення договору",
            secondary: "Найшвидше припинення договору у місті",
            description: "Маєте досить? Час на зміни? А може, була краща пропозиція? Не чекайте – скористайтеся нашим генератором припинення договору і киньте папір уже сьогодні!"
        },
        ui: {
            generateBtn: "Генерувати припинення трудового договору",
            downloadBtn: "Завантажити",
            langSelector: "язик",
            cookieInfoMessage: "Веб-сайт використовує файли cookie для надання послуг відповідно до <a href=\"polityka-prywatnosci\">Політики конфіденційності</a>. Ви можете визначити умови зберігання або доступу до механізму cookie у своєму браузері.",
            cookieInfoAcceptBtn: "я приймаю"
        },
        form: {
            contractType: "Тип договору",
            contractOfEmployment: "Трудовий договір",
            contractOfWork: "Договір доручення",
            contractB2B: "Б2Б",
            employee: "Співробітник",
            contractor: "Підрядник",
            nameAndSurname: "Ім'я та Прізвище",
            contractorComanyName: "Назва фірми",
            address: "Адреса",
            city: "Місто",
            postalCode: "Поштовий індекс",
            employer: "Роботодавець",
            customer: "Замовник",
            comanyName: "Назва",
            companyTaxNr: "ІПН",
            noticePeriod: "Термін попередження",
            noticePeriodOneMonth: "1 місяць",
            noticePeriodThreeMonths: "3 місяці",
            noticePeriodOther: "Інший",
            noticePeriodPlaceholder: "(нп. 14 днів)",
            additionalInfo: "Додаткова інформація",
            dateOfNotice: "Дата подання повідомлення про припинення",
            contractDate: "Дата укладення договору",
            contractNumber: "Номер договору (необов'язково)",
            validationMsg: "Форма містить помилки"
        }
    }
};

export default translations;